/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
var isZeroValueString = function (v) { return /^0[^.\s]+$/.test(v); };

export { isZeroValueString };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/is-zero-value-string.mjs
// module id = wStl
// module chunks = 0